const API_URL = (process.env.REACT_APP_API_URL || 'https://singlesystem.com.br:4937').replace(/\/$/, '');

/**
 * Envia e-mail pela API Spring Boot.
 * POST {API_URL}/email/enviar
 * Body: { subject, replyTo, fields }
 */
export async function sendEmail({ subject, replyTo, fields }) {
  const url = `${API_URL}/email/enviar`;
  const body = JSON.stringify({ subject, replyTo, fields });

  let response;
  try {
    response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, text/plain, */*',
      },
      body,
    });
  } catch (networkErr) {
    throw networkErr;
  }

  const text = await response.text();
  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = { message: text };
  }

  if (!response.ok) {
    throw new Error(
      data.message || text || 'Não foi possível enviar o e-mail.'
    );
  }

  return data.message || text || { success: true };
}
